module.exports = __webpack_public_path__ + "static/media/Un_llamado_a_revolucionar_el_sector.210801c6.jpg";